import React, { useState } from 'react';
import { translate } from '../../../services/translate';
import { Modal, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { WindowInformation } from '../../../services/window-information';
import FormActions from '../../../components/FormActions';
import Toast from 'react-native-toast-message';
import { ClientError } from '../../../services/central-api/base-service';
import FormInput from '../../../components/FormInput';
import { armoryService } from '../../../services/central-api/armory';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onClose: () => void;
    onSave: () => void;
    armoryShiftId: number;
}

function DeleteArmoryShiftModal({ isModalVisible, setModalVisible, armoryShiftId, onClose, onSave }: ModalProps) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [reason, setReason] = useState<string>('');

    function isReasonInvalid(value: string) {
        return value == '';
    }

    async function confirmDelete() {
        try {
            await armoryService.deleteArmoryShift(armoryShiftId, reason);
            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
            setReason('');
            setModalVisible(false);
            onSave();
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <Modal
            transparent={true}
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                setModalVisible(false);
                setReason('');
                onClose();
            }}
        >
            <View style={styles.container}>
                <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : { width: '20%' }]}>
                    <View style={{ flexDirection: 'column', gap: 16, justifyContent: 'center', alignItems: 'center' }}>
                        <MyAppText style={{ fontSize: 18, fontWeight: 'bold' }}>{translate('attention')}!</MyAppText>
                        <FontAwesomeIcon icon={faExclamationTriangle as IconDefinition} fontSize={45} color={theme.colors.errors['300']} />
                        <MyAppText style={{ textAlign: 'center' }}>{translate('deleteReasonShift')}:</MyAppText>
                    </View>
                    <FormInput
                        label={translate('reason')}
                        placeholder={translate('reason')}
                        value={reason}
                        onChangeText={setReason}
                        invalid={isReasonInvalid}
                        multiline={true}
                    />
                    <FormActions
                        onSubmit={async () => {
                            setModalVisible(false);
                            await confirmDelete();
                        }}
                        confirmText='delete'
                        confirmType='destructive'
                        onClose={() => {
                            setModalVisible(false);
                            setReason('');
                            onClose();
                        }}
                        disabled={!reason} />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        minWidth: 300,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25
    }
}));


export default DeleteArmoryShiftModal;
